import {
  FUND_INVESTMENTS_MEASUREMENT_TITLE,
  FUND_INVESTMENTS_TITLE_SINGULAR,
} from 'pages/FundInvestments/common/constants/fundInvestmentsBase';

export const FUND_INVESTMENTS_FORM_ADD_TITLE = `Add ${FUND_INVESTMENTS_TITLE_SINGULAR}`;
export const FUND_INVESTMENTS_FORM_DELETE_TITLE = `Delete ${FUND_INVESTMENTS_TITLE_SINGULAR}`;
export const FUND_INVESTMENTS_FORM_DELETE_TOOLTIP = `A ${FUND_INVESTMENTS_TITLE_SINGULAR} cannot be deleted if it has a ${FUND_INVESTMENTS_MEASUREMENT_TITLE}`;
export const FUND_INVESTMENTS_FORM_LABELS = {
  name: `${FUND_INVESTMENTS_TITLE_SINGULAR} Name`,
  legal_company_name: `${FUND_INVESTMENTS_TITLE_SINGULAR} Legal Name`,
  website: 'Website',
  captable_currency: 'Currency',
  fiscal_year_end: 'FY End',
  fiscal_year_end_month: 'Month',
  fiscal_year_end_day: 'Day',
  vintage_year: 'Vintage Year',
};
